export default {
	getOnlyXY: (coordinates, { isMultiPolygon = false } = {}) => {
		return coordinates.map(
			coords => {
				if (isMultiPolygon) {
					return coords.map(coord => {
						return coord.map(innerCoord => {
							return innerCoord.filter((_, index) => index < 2);
						})
					})
				}

				return coords.map(coord => {
					return coord.filter((_, index) => index < 2);
				})
			}
		);
	},
	reverseCoordinates: (coordinates, { isMultiPolygon = false } = {}) => {
		return coordinates.map(coords => {
			if (isMultiPolygon) {
				return coords.map(coord => {
					return coord.map(innerCoord => {
						return [...innerCoord].reverse()
					})
				})
			}

			return coords.map(coord => {
				return [...coord].reverse()
			})
		});
	}
}